<template>
  <section class="t-split-screen" :class="[{ 't-split-screen--wide': wide }]">
    <div class="t-split-screen__primary">
      <div class="t-split-screen__primary-content">
        <slot></slot>
      </div>
    </div>
    <div
      class="t-split-screen__secondary"
      :class="[{ 't-split-screen__secondary--centered': centered }]"
    >
      <slot name="secondary"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 't-split-screen',

  props: {
    centered: Boolean,
    wide: Boolean,
  },
};
</script>
